import { WEBSOCKET_CHAT_API_URL } from "utils/env-management"

// ls
export const LS_CLIENT_TOKEN = "clientToken"
export const LS_PSY_TOKEN = "psyToken"

// urls
export const WEBSOCKET_CONNECT_URL = `${WEBSOCKET_CHAT_API_URL}/ws?token=`
export const GET_CLIENT_LIST_URL = "/chat/client/list"
export const GET_PSY_LIST_URL = "/chat/psychologist/list"
export const GET_CHAT_CLIENT_URL = "/chat/client/get"
export const GET_CHAT_PSY_URL = "/chat/psychologist/get"
export const GET_CLIENT_TOKEN_URL = "chat/client/jwt"
export const GET_PSY_TOKEN_URL = "chat/psychologist/jwt"
